import { FunctionComponent, memo, useMemo } from 'react';
import { Helmet } from 'react-helmet';

type AppHelmetProps = {
  title?: string;
  description?: string;
  keywords?: string;
};

const AppHelmet: FunctionComponent<AppHelmetProps> = props => {
  const { title, description = '', keywords } = props;
  const SEOKeywords = useMemo(() => keywords || 'Booking FDO', [keywords]);
  const appName = 'Booking FDO';

  const pageTitle = title ? `${appName} - ${title}` : appName;

  return (
    <Helmet>
      <title>{pageTitle}</title>

      <meta name="description" content={description} />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="robots" content="index, follow" />
      <meta key="googlebot" name="googlebot" content="index,follow" />
      <meta name="google" content="notranslate" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="keywords" content={SEOKeywords} />
    </Helmet>
  );
};

export default memo(AppHelmet);
